<app-stages [stages]="stages" currentStage="Informacje na temat inwestycji"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class="col-12">
        <div class='form-group' *ngIf='"investmentLocation" as controlName'>
          <label [for]='controlName'>
            Lokalizacja inwestycji *
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu lokalizację inwestycji'>
            </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"investmentPurpose" as controlName'>
          <label [for]='controlName'>
            Cel inwestycji *
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu cel inwestycji'>
            </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"investmentSchedule" as controlName'>
          <label [for]='controlName'>
            Harmonogram inwestycji *
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu harmonogram'>
            </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"investmentInfrastructureRequirements" as controlName'>
          <label [for]='controlName'>
            Wymagania infrastrukturalne inwestycji *
          </label>
          <textarea
            rows="3"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu wymagania'>
            </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
      <span>
        Wstecz
      </span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
